// extracted by mini-css-extract-plugin
module.exports = {"timer":"PhaseTimer_timer__0BV88","warning":"PhaseTimer_warning__83HBu"};